module.exports = __webpack_public_path__ + "img/c3 white.c2be7ad9.png";